import { render, staticRenderFns } from "./ApproveOfferGalleryDialog.vue?vue&type=template&id=08c17c3f&scoped=true"
import script from "./ApproveOfferGalleryDialog.vue?vue&type=script&lang=js"
export * from "./ApproveOfferGalleryDialog.vue?vue&type=script&lang=js"
import style0 from "./ApproveOfferGalleryDialog.vue?vue&type=style&index=0&id=08c17c3f&prod&lang=scss"
import style1 from "./ApproveOfferGalleryDialog.vue?vue&type=style&index=1&id=08c17c3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c17c3f",
  null
  
)

/* custom blocks */
import block0 from "./ApproveOfferGalleryDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports